import { EditorProviderButtonSettings } from '../EditorProviderButtonSettings';
import { customizeCraftJsComponent } from '../../helpers';
import { EditorButton } from '../EditorButton';

export const EditorFacebookButton = customizeCraftJsComponent(EditorButton, {
	name: 'Facebook Button',
	props: {
		children: '',
		startIcon: 'facebook',
		shape: 'square',
		variant: 'outline',
		'data-descope-provider': 'facebook',
		startIconColorText: false,
		formNoValidate: true,
		'data-type': 'social'
	},
	related: {
		settings: EditorProviderButtonSettings
	},
	custom: {
		subType: 'social'
	}
});
